import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-info-line",
  templateUrl: "./info-line.component.html",
  styleUrls: ["./info-line.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InfoLineComponent {
  @Input() icon: string;
  @Input() svgIcon: string;
  @Input() title: string;
  @Input() subtitles: string[];
  @Input() showBadge: boolean;
  @Input() workspaces = [];
}
